import { configureStore } from '@reduxjs/toolkit'
import userReducer from './slice/user' 
import productReducer from './slice/product'
import orderReducer from './slice/order'
import localRecucer from './slice/local'
import { loadUserState, saveUserState } from "../utils/storage";

const preloadedState = {
  user: loadUserState(), // 👈 load from localStorage
};

const store = configureStore({
  reducer : {
    user: userReducer, 
    product: productReducer, 
    order: orderReducer,
    local: localRecucer
  },
  preloadedState,
})
// 🔥 SAVE ON EVERY CHANGE
store.subscribe(() => {
  saveUserState(store.getState().user);
});

export default store